// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eFXI1nNjZvMsdkIeosCI{height:24px;padding:8px !important}`, "",{"version":3,"sources":["webpack://./src/pages/contacts/pages/cleanup/ui/ContactsUnlinkedTable/ui/LinkContact/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,sBAAA","sourcesContent":[".linkButton {\n  height: 24px;\n  padding: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkButton": `eFXI1nNjZvMsdkIeosCI`
};
export default ___CSS_LOADER_EXPORT___;
